import { createFragmentContainer, graphql } from 'react-relay';
import TemplateList from './TemplateList';

export default createFragmentContainer(TemplateList, {
  viewer: graphql`
    fragment TemplateListContainer_viewer on User {
      ...AvailabilityCheckerContainer_viewer
      id
      c_templates {
        edges {
          node {
            id
            title
          }
        }
      }
      form_templates {
        edges {
          node {
            id
            title
          }
        }
      }
      mp_templates {
        edges {
          node {
            id
            title
            can_edit
            public
          }
        }
      }
      public_mp_templates {
        edges {
          node {
            id
            title
            can_edit
            public
          }
        }
      }
      primary_brand {
        id
      }
      features {
        music_lists
      }
    }
  `
});



// WEBPACK FOOTER //
// ./webpack/components/Document/Template/TemplateListContainer.js